// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-bg-outline {
    display: flex;
    background-image: linear-gradient(
        72deg, #f0f6, #f006, #f806, #ff26
    );
    border-color: #000;
    border-style: solid;
    background-size: cover;
    background-position: center;
    gap: 20px;
    color: white;
    box-sizing: border-box;
}

.profile-bg-container {
    display: flex;
    flex-direction: column;
    padding: 15px 25px;
    gap: 10px;
    box-sizing: border-box;
    overflow: hidden;
    width: 100%;
    height: 100%;
    background-color: #000;
}

.pd-top {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.pd-compact-profile {
    width: 50%;
    background-image: linear-gradient(90deg, #8881 15%, #8883 50%, #8881 85%);
    filter: drop-shadow(-1px 1px 5px #88a4);
    color: #fff;
    padding: 10px;
    box-sizing: border-box;
}
@media screen and (max-width: 1200px) {
    .pd-top {
        flex-direction: column !important;
        align-items: center;
    }
    .pd-compact-profile {
        width: 100% !important;
    }
    .statbox-container {
        width: 100% !important;
        padding: 5px 0;
    }
}

.pd-bottom {
    border-top: 1px solid #8888;
    padding-top: 5px;
    word-wrap: break-word;
    width: 100%;
}

/*flex-row padding-x-20px align-center justify-evenly width-100 border-box*/
.statbox-container {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    box-sizing: border-box;
    width: 50%;
    flex-grow: 1;
}

.profile-statbox {
    display: flex;
    flex-direction: column;
    align-items: center;
    white-space: nowrap;
}

.stat-figure {
    font-family: var(--displayFont);
    font-weight: 800;
    margin: 0;
    padding: 0;
}
.stat-label {
    font-weight: 600;
    margin: 0;
    padding: 0;
}

.green-gradient-text {
    background: linear-gradient(72deg, #03cd43, #007e89);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.orange-gradient-text {
    background: linear-gradient(72deg, #ffd738, rgb(216, 160, 4));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.purple-gradient-text {
    background: linear-gradient(72deg, #a600ff, #7007c6);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/styles/general/ProfileDisplay.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb;;KAEC;IACD,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;IAC3B,SAAS;IACT,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,UAAU;IACV,yEAAyE;IACzE,uCAAuC;IACvC,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI;QACI,iCAAiC;QACjC,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;QACtB,cAAc;IAClB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;AACf;;AAEA,2EAA2E;AAC3E;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,oDAAoD;IACpD,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,oDAAoD;IACpD,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;AACxC","sourcesContent":[".profile-bg-outline {\n    display: flex;\n    background-image: linear-gradient(\n        72deg, #f0f6, #f006, #f806, #ff26\n    );\n    border-color: #000;\n    border-style: solid;\n    background-size: cover;\n    background-position: center;\n    gap: 20px;\n    color: white;\n    box-sizing: border-box;\n}\n\n.profile-bg-container {\n    display: flex;\n    flex-direction: column;\n    padding: 15px 25px;\n    gap: 10px;\n    box-sizing: border-box;\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n    background-color: #000;\n}\n\n.pd-top {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n.pd-compact-profile {\n    width: 50%;\n    background-image: linear-gradient(90deg, #8881 15%, #8883 50%, #8881 85%);\n    filter: drop-shadow(-1px 1px 5px #88a4);\n    color: #fff;\n    padding: 10px;\n    box-sizing: border-box;\n}\n@media screen and (max-width: 1200px) {\n    .pd-top {\n        flex-direction: column !important;\n        align-items: center;\n    }\n    .pd-compact-profile {\n        width: 100% !important;\n    }\n    .statbox-container {\n        width: 100% !important;\n        padding: 5px 0;\n    }\n}\n\n.pd-bottom {\n    border-top: 1px solid #8888;\n    padding-top: 5px;\n    word-wrap: break-word;\n    width: 100%;\n}\n\n/*flex-row padding-x-20px align-center justify-evenly width-100 border-box*/\n.statbox-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n    gap: 10px;\n    align-items: center;\n    box-sizing: border-box;\n    width: 50%;\n    flex-grow: 1;\n}\n\n.profile-statbox {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    white-space: nowrap;\n}\n\n.stat-figure {\n    font-family: var(--displayFont);\n    font-weight: 800;\n    margin: 0;\n    padding: 0;\n}\n.stat-label {\n    font-weight: 600;\n    margin: 0;\n    padding: 0;\n}\n\n.green-gradient-text {\n    background: linear-gradient(72deg, #03cd43, #007e89);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.orange-gradient-text {\n    background: linear-gradient(72deg, #ffd738, rgb(216, 160, 4));\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.purple-gradient-text {\n    background: linear-gradient(72deg, #a600ff, #7007c6);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
